import { useEffect, useMemo } from "react"
import { useDispatch } from "react-redux"
import Stack from "@mui/material/Stack"
import { WishamNotification } from "types/notification.types"
import { categorizeNotifications } from "utils/componentsUtils"
import { useAppSelector } from "appRedux/hooks"
import {
  resetNotificationsPage,
  updateNotifications,
  updateUnseenNotificationsCount
} from "appRedux/slices/notificationSlice"
import { useGetFollowRequestsQuery } from "appRedux/slices/userApiSlice"
import { useGetNotificationsQuery, useSeenNotificationMutation } from "appRedux/slices/notificationApiSlice"
import FollowRequestsNotificationBar from "components/molecules/FollowRequestsNotificationBar"
import CategorizedNotificationsBasedOnTime from "components/molecules/CategorizedNotificationsBasedOnTime"

export default function NotificationsPage() {
  const notifications = useAppSelector((state) => state.notification.notifications)
  const followRequests = useAppSelector((state) => state.user.followRequests)

  useGetNotificationsQuery(1, {
    refetchOnMountOrArgChange: true
  })

  useGetFollowRequestsQuery(undefined, {
    refetchOnMountOrArgChange: true
  })

  const [triggerSeenNotification] = useSeenNotificationMutation()

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updateUnseenNotificationsCount(0))
    dispatch(resetNotificationsPage())
  }, [])

  useEffect(() => {
    const unseenNotificationIds: number[] = []
    const seenNotifications = notifications.map((notif: WishamNotification) => {
      if (!notif.seen) {
        unseenNotificationIds.push(notif.id)
        return { ...notif, seen: true }
      }
      return notif
    })
    if (!unseenNotificationIds.length) return
    triggerSeenNotification({ notificationIds: unseenNotificationIds })
    dispatch(updateNotifications(seenNotifications))
  }, [notifications])

  const categorizedNotifications = useMemo(() => categorizeNotifications(notifications), [notifications])

  return (
    <Stack gap={"8px"}>
      <FollowRequestsNotificationBar notifications={followRequests}/>
      <CategorizedNotificationsBasedOnTime categorizedNotifications={categorizedNotifications}/>
    </Stack>
  )
}
